import { zodResolver } from '@hookform/resolvers/zod';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { z } from 'zod';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { supabase } from '@/lib/supabase/client';

const schema = z.object({ email: z.string().email('Email inválido') });
type Values = z.infer<typeof schema>;

export const Route = createFileRoute('/_auth/reset-password')({
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const [sent, setSent] = useState(false);

  const form = useForm<Values>({
    resolver: zodResolver(schema),
    defaultValues: { email: '' },
  });

  const onSubmit = form.handleSubmit(async (v) => {
    const { error } = await supabase.auth.resetPasswordForEmail(v.email, {
      redirectTo: `${window.location.origin}/reset-password/confirm`,
    });
    if (error) {
      toast.error(error.message);
      return;
    }
    setSent(true);
  });

  if (sent) {
    return (
      <div className="text-center space-y-2">
        <h1 className="text-lg font-semibold text-ink">Revisa tu email</h1>
        <p className="text-sm text-quiet">Te enviamos un link para restablecer la contraseña.</p>
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-4" noValidate>
      <div>
        {/* i18n */}
        <h1 className="text-xl font-semibold text-ink">Restablecer contraseña</h1>
        <p className="mt-1 text-sm text-quiet">
          Te enviaremos un link a tu email para crear una nueva contraseña.
        </p>
      </div>

      <div className="flex flex-col gap-1.5">
        <Label htmlFor="reset-email">Email</Label>
        <Input id="reset-email" type="email" autoComplete="email" {...form.register('email')} />
        {form.formState.errors.email && (
          <span className="text-xs text-critical">{form.formState.errors.email.message}</span>
        )}
      </div>

      <Button type="submit" disabled={form.formState.isSubmitting}>
        {form.formState.isSubmitting ? 'Enviando...' : 'Enviar link'}
      </Button>
    </form>
  );
}
